<template>
    <ModalFormCard :action="action" :submittedCallback="submittedCallback" class="modal-default">
        <template #title>Add subscription</template>

        <template #default="{ saving, errors }">

        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],
}
</script>
